export const fissionRedEnvelopeRouter = [
  {
    path: '/service/fissionRedEnvelope/list',
    name: 'FissionRedEnvelope',
    component: () => import('@/views/service/serviceProvider/fissionRedEnvelope/FissionRedEnvelope'),
    meta: {
      title: '裂变红包',
      keepAlive: false
    }
  },
  {
    path: '/service/fissionRedEnvelope/addRed',
    name: 'AddRedEnvelope',
    component: () => import('@/views/service/serviceProvider/fissionRedEnvelope/AddRedEnvelope'),
    meta: {
      title: '新建活动',
      keepAlive: false
    }
  }
]